<div class="mx-md-5 mx-4 mt-md-5 mt-4">
  <h5>{{ 'jobApplyCV.areYouUploadingExistingResume' | translate }}</h5>
  <p>{{ 'jobApplyCV.justReviewEditAndUpdate' | translate }}</p>
</div>

<div class="row m-md-4 m-3">

  <!-- Section 1: Upload New CV -->
  <div class="col-12 col-sm-6 mt-3 mt-sm-auto">
    <div class="card-container" (click)="selectResumeType('upload')"
      [ngClass]="{ selected: selectedResumeType === 'upload' }">
      <img class="mx-auto mb-3" src="../../../../../../assets/img/upload resume.png" />
      <h5>{{ 'jobApplyCV.uploadMyResume' | translate }}</h5>
      <p>{{ 'jobApplyCV.uploadYourCV' | translate }}</p>

      <div class="view-cv-section" *ngIf="selectedResumeType === 'upload'">
        <label for="cvFileInput" class="view-cv-btn">
          <i class="bi bi-upload"></i>
          {{ uploadedCV ? ('jobApplyCV.changeCV' | translate) : ('jobApplyCV.uploadCV' | translate) }}
        </label>
        <input id="cvFileInput" type="file" accept=".pdf,.doc,.docx"
          (change)="onCVSelected($event)"
          (click)="$event.stopPropagation()"
          style="display: none;">

        <div class="selected-cv-info" *ngIf="uploadedCV">
          <div class="selected-badge">
            <i class="bi bi-file-earmark-check-fill"></i>
            <span>{{ uploadedCV.name }}</span>
          </div>
          <button class="remove-selection" (click)="removeCV(); $event.stopPropagation()">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </div>

      <input *ngIf="selectedResumeType === 'upload'" type="radio" checked />
    </div>
  </div>

  <!-- Section 2: Use Generated CV -->
  <div class="col-12 col-sm-6 mt-3 mt-sm-auto">
    <div class="card-container" (click)="selectResumeType('current')"
      [ngClass]="{ selected: selectedResumeType === 'current' }">
      <img class="mx-auto mb-3 current" src="../../../../../../assets/img/upload cv.png" />
      <h5>{{ 'jobApplyCV.useYourCurrentCV' | translate }}</h5>

      <div class="view-cv-section" *ngIf="selectedResumeType === 'current'">
        <button class="view-cv-btn" (click)="openCVSelectionPopup(); $event.stopPropagation()">
          <i class="bi bi-eye"></i>
          {{ 'jobApplyCV.viewAndSelectCV' | translate }}
        </button>

        <div class="selected-cv-info" *ngIf="selectedCV">
          <div class="selected-badge">
            <i class="bi bi-check-circle-fill"></i>
            <span>{{ 'jobApplyCV.cvSelected' | translate }}</span>
          </div>
          <button class="remove-selection" (click)="removeSelectedCV(); $event.stopPropagation()">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </div>

      <input *ngIf="selectedResumeType === 'current'" type="radio" checked />
    </div>
  </div>
</div>

<div class="actions-row">
  <button class="cancel-btn border-button" type="button" (click)="onCancel()">
    {{ 'jobApplyCV.back' | translate }}
  </button>
  <button class="next-btn gradient-button" type="button" (click)="onNext()" [disabled]="!canProceed()">
    {{ 'jobApplyCV.submit' | translate }}
  </button>
</div>

<!-- ══════════════ CV Selection Popup ══════════════ -->
<div class="popup-overlay" *ngIf="showCVSelectionPopup" (click)="closeCVSelectionPopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h3>{{ 'jobApplyCV.selectYourCV' | translate }}</h3>
      <button class="close-btn" (click)="closeCVSelectionPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="loading-container" *ngIf="loadingCvs">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p>{{ 'jobApplyCV.loadingYourCVs' | translate }}</p>
    </div>

    <div class="error-container" *ngIf="errorCvs && !loadingCvs">
      <i class="bi bi-exclamation-circle"></i>
      <p>{{ errorCvs | translate }}</p>
      <button class="retry-btn" (click)="loadMyCvs()">
        {{ 'jobApplyCV.retry' | translate }}
      </button>
    </div>

    <div class="cvs-container" *ngIf="!loadingCvs && !errorCvs">
      <div class="empty-state" *ngIf="myCvs.length === 0">
        <i class="bi bi-file-earmark-text"></i>
        <p>{{ 'jobApplyCV.noCVsAvailable' | translate }}</p>
        <small>{{ 'jobApplyCV.generateCVToSeeItHere' | translate }}</small>
      </div>

      <div class="cv-grid" *ngIf="myCvs.length > 0">
        <div class="cv-item"
             *ngFor="let cv of myCvs; let i = index"
             (click)="selectCVFromPopup(cv)">
          <div class="cv-image-container">
            <div class="image-loading" *ngIf="!cvImageUrls[cv.imagePath]">
              <div class="spinner-border spinner-border-sm text-danger" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <img
              *ngIf="cvImageUrls[cv.imagePath]"
              [src]="getImageUrl(cv.imagePath)"
              [alt]="'CV Template ' + (i + 1)"
              (contextmenu)="disableRightClick($event)" />
            <div class="cv-overlay">
              <i class="bi bi-check-circle-fill"></i>
              <span>{{ 'jobApplyCV.select' | translate }}</span>
            </div>
          </div>
          <div class="cv-info">
            <span class="cv-number">CV #{{ i + 1 }}</span>
            <div class="cv-badges">
              <span class="badge badge-pdf" *ngIf="cv.pdfPath">
                <i class="bi bi-file-pdf"></i> PDF
              </span>
              <span class="badge badge-word" *ngIf="cv.wordPath">
                <i class="bi bi-file-word"></i> Word
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>